import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppProvider } from "./Components/Context";
import PumpDetailsProvider from "./Context/PumpDetailsContext";
import StateContextProvider from "./Context/StateContext";
import ScheduleContextProvider from "./Components/ScheduleContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <PumpDetailsProvider>
      <StateContextProvider>
        <AppProvider>
          {/* <ScheduleContextProvider> */}
            <App />
          {/* </ScheduleContextProvider> */}
        </AppProvider>
      </StateContextProvider>
    </PumpDetailsProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
